<script>
    export let params;
    import { redirect } from "./pager";
    import { session } from "./components/js/store.js";
    let sessions;
    $: sessions;
    session.subscribe((value) => {
        sessions = value;
    });
    if (params.path) {
        setTimeout(() => {
            redirect("/" + params.path);
        }, 1000);
    } else {
        {
            redirect("/NotFound");
        }
    }
</script>
